<template>
  <b-modal v-model="show" size="lg" @close="onCancel">
    <template v-slot:modal-title>{{ $t("commons.html_editor") }}</template>
    <div class="my-2">
      <b-tabs content-class="mt-3" @input="setContent">
        <b-tab :title="$t('commons.rich_editor')" active>
          <vue-editor v-model="content" :editor-toolbar="customToolbar" />
        </b-tab>
        <b-tab :title="$t('commons.plain_text_editor')">
          <b-form-textarea
            v-model="contentText"
            class="textarea"
            maxlines="10"
          ></b-form-textarea>
        </b-tab>
      </b-tabs>
    </div>
    <template v-slot:modal-footer>
      <b-button
        type="submit"
        variant="primary"
        @click="onConfirm"
        v-text="$t('buttons.ok')"
      />
      <b-button
        type="reset"
        variant="danger"
        @click="onCancel"
        v-text="$t('buttons.cancel')"
      />
    </template>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      content: "",
      contentText: "",
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        ["blockquote", "code-block"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
          {
            list: "check",
          },
        ],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ], // outdent/indent
        [
          {
            color: [],
          },
          {
            background: [],
          },
        ], // dropdown with defaults from theme
        ["link", "image", "video"],
        ["clean"], // remove formatting button
      ],
    };
  },
  methods: {
    open(content) {
      this.content = this.contentText = content;
      this.show = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onConfirm() {
      this.resolve(this.content);
      this.show = false;
    },
    onCancel() {
      this.resolve(false);
      this.show = false;
    },
    setContent(tabIndex) {
      if (tabIndex == 0) {
        this.content = this.contentText;
      } else if (tabIndex == 1) {
        this.contentText = this.content;
      }
    },
  },
};
</script>
